import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'did_the_fac_experience_exceptional_circumstances_ie_large_late'

export const dataPointDefinition = {
  retracedId: 'did_the_fac_experience_exceptional_circumstances_ie_large_late',
  name: 'Did the facility experience exceptional circumstances (i.e. large late customer change orders, weather disasters etc.) that resulted in significant changes to its production schedules?',
  description:
    'The intent of this question is to understand if the facility experienced circumstances, which substantially disrupt production and are out of the ordinary/out of the control of the facility. \r\r\n\r\r\nCircumstances including natural disasters, power outages or national emergencies. Excludes peak production periods, holidays or expected seasonal fluctuations. \r\r\n\r\r\nNOTE: If customer orders are a reason (i.e. late changes), please DO NOT mention specific customer names (i.e. Brand X).',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fl-8',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7030,
  sectionId: '2.2.12',
  impactArea: 'Working Hours',
  impactAreaId: 'WORKING_HOURS_AND_OVERTIME',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
